var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"last-update"},[_vm._v(_vm._s(_vm.$t("groups.lastUpdate"))+" "+_vm._s(_vm.formatDate()))])
}
var staticRenderFns = []

export { render, staticRenderFns }